import { render, staticRenderFns } from "./vantUploadImage.vue?vue&type=template&id=1b924432&scoped=true"
import script from "./vantUploadImage.vue?vue&type=script&lang=js"
export * from "./vantUploadImage.vue?vue&type=script&lang=js"
import style0 from "./vantUploadImage.vue?vue&type=style&index=0&id=1b924432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b924432",
  null
  
)

export default component.exports